import { render, staticRenderFns } from "./StudentHistoryChat.vue?vue&type=template&id=fa645040&scoped=true&lang=pug&"
import script from "./StudentHistoryChat.vue?vue&type=script&lang=ts&"
export * from "./StudentHistoryChat.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistoryChat.vue?vue&type=style&index=0&id=fa645040&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa645040",
  null
  
)

export default component.exports